import store from '../store/store';
import { mutatorAction } from 'satcheljs';
import { DomainConnectFetchSetupResponse } from 'owa-domain-connect';

export default mutatorAction('setDomainState', function setDomainState(
    response: DomainConnectFetchSetupResponse
) {
    store.domainState.isInitialized = true;
    var domainDataItem = response.domainData;
    if (domainDataItem) {
        store.domainState.isValid = domainDataItem.isDomainValidated;
        store.domainState.domainName = domainDataItem.domainName;
        store.domainState.isDomainCreated = true;
        store.domainState.domainPurchaseDate = new Date(domainDataItem.domainPurchaseDate);
        store.domainState.dnsRecordValue = domainDataItem.dnsRecordValue;
    } else {
        store.domainState.isDomainCreated = false;
        store.domainState.isValid = false;
        store.domainState.domainName = '';
    }
});
